import React from "react";

const Footer = () => {
  return (
    <>
      <p className="footer">
        {/* This Program is Developed By <span>BODYPROCOACH</span> */}
      </p>
    </>
  );
};

export default Footer;
